import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderList as _renderList, vModelCheckbox as _vModelCheckbox, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4d905a60"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "d-sm-flex align-items-center" }
const _hoisted_4 = {
  key: 0,
  class: "select-calendar position-relative me-sm-10 ms-sm-15 mt-10 mt-sm-0"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-calendar lh-1 icon" }, null, -1))
const _hoisted_6 = {
  ref: "timeline",
  type: "text",
  class: "form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16",
  id: "timeline"
}
const _hoisted_7 = { class: "dropdown mt-10 mt-sm-0 ms-sm-10 me-4" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ph ph-funnel" }, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "d-sm-flex align-items-center mt-10 mt-lg-0" }
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<option value=\"PASD\" data-v-4d905a60>Pass</option><option value=\"INPRG\" data-v-4d905a60>In Progress</option><option value=\"1STMT\" data-v-4d905a60>1st Meeting</option><option value=\"2NDMT\" data-v-4d905a60>2nd Meeting</option><option value=\"INVST\" data-v-4d905a60>Invested</option>", 5)
const _hoisted_16 = [
  _hoisted_11
]
const _hoisted_17 = { class: "dropdown me-3 mt-10 mt-sm-0 ms-sm-10" }
const _hoisted_18 = {
  key: 1,
  class: "mt-10 mt-sm-0 ms-sm-10"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "dropdown-toggle card-dot-btn lh-1 position-relative top-4 bg-transparent border-0 shadow-none p-0 transition",
  type: "button",
  "data-bs-toggle": "offcanvas",
  "data-bs-target": "#companiesSettings",
  "aria-controls": "offcanvasRight"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-setting" })
], -1))
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = {
  key: 0,
  class: "d-flex flex-column flex-wrap justify-content-start p-4"
}
const _hoisted_22 = {
  class: "nav nav-pills nav-sm",
  id: "myTab",
  role: "tablist"
}
const _hoisted_23 = {
  class: "nav-item me-2",
  role: "presentation"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-flash me-1 mt-1 align-middle" }, null, -1))
const _hoisted_25 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-settings me-1 mt-1 align-middle" }, null, -1))
const _hoisted_27 = {
  class: "tab-content mt-20 bg-gray pt-25 ps-25 pe-25 pb-25",
  id: "myTabContent"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-semibold mx-2 mb-5 fs-6" }, "Status", -1))
const _hoisted_29 = { class: "mx-2 mb-25 d-flex align-items-center" }
const _hoisted_30 = {
  class: "btn-group btn-group-sm mt-1",
  role: "group"
}
const _hoisted_31 = ["value"]
const _hoisted_32 = {
  class: "tab-pane fade show active",
  id: "alignment-tab-pane",
  role: "tabpanel",
  tabindex: "0"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-semibold mx-2 mb-5 fs-6" }, "Alignment", -1))
const _hoisted_34 = { class: "mx-2 mb-2 d-flex align-items-center" }
const _hoisted_35 = {
  class: "btn-group btn-group-sm mt-1",
  role: "group"
}
const _hoisted_36 = ["value"]
const _hoisted_37 = {
  class: "tab-pane fade",
  id: "custom-tab-pane",
  role: "tabpanel",
  tabindex: "0"
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-semibold mx-2 mb-5 fs-6" }, "Gap Closing", -1))
const _hoisted_39 = { class: "mx-2 mb-20 d-flex align-items-center" }
const _hoisted_40 = {
  class: "btn-group btn-group-sm mt-1",
  role: "group"
}
const _hoisted_41 = ["value"]
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mt-10 fw-semibold mx-2 mb-5 fs-6" }, "Stage", -1))
const _hoisted_43 = { class: "mx-2 mb-20 d-flex align-items-center" }
const _hoisted_44 = {
  class: "btn-group btn-group-sm mt-1",
  role: "group"
}
const _hoisted_45 = ["value"]
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-semibold mx-2 mb-5 fs-6" }, "Customer Type", -1))
const _hoisted_47 = { class: "mx-2 mb-20 d-flex align-items-center" }
const _hoisted_48 = {
  class: "btn-group btn-group-sm mt-1",
  role: "group"
}
const _hoisted_49 = ["value"]
const _hoisted_50 = { class: "mx-2 mb-2" }
const _hoisted_51 = { class: "mb-2 d-flex align-items-center" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-semibold fs-6" }, "Segments", -1))
const _hoisted_53 = {
  class: "btn-group btn-group-sm flex-wrap",
  role: "group"
}
const _hoisted_54 = ["value"]
const _hoisted_55 = { class: "w-100 d-flex space-content" }
const _hoisted_56 = { class: "mt-4 pe-1 w-100 d-flex justify-content-end" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-next ms-1 mt-1 align-middle" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (!_ctx.isPrecisionPicks)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("input", _hoisted_6, null, 512)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("button", {
            class: "dropdown-toggle card-dot-btn lh-1 position-relative top-4 bg-transparent border-0 shadow-none p-0 transition",
            type: "button",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleCollapse && _ctx.toggleCollapse(...args))),
            "aria-expanded": "false"
          }, _hoisted_9)
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        (!_ctx.isGridView && _ctx.canAccessFeature('inboundListActions') && _ctx.isActionsEnabled)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedStatus) = $event)),
                class: "project-select form-select shadow-none fw-semibold rounded-1 mt-10 mt-sm-0"
              }, _hoisted_16, 512), [
                [_vModelSelect, _ctx.selectedStatus]
              ]),
              _createElementVNode("button", {
                class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block d-inline-block text-decoration-none ms-sm-10 me-2",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.callStatusUpdateFunction && _ctx.callStatusUpdateFunction(...args)))
              }, " Do Action ")
            ], 64))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("button", {
            class: "dropdown-toggle card-dot-btn lh-1 position-relative top-4 bg-transparent border-0 shadow-none p-0 transition",
            type: "button",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toggleView && _ctx.toggleView(...args)))
          }, [
            _createElementVNode("i", {
              class: _normalizeClass(_ctx.isGridView ? 'flaticon-menu-1' : 'flaticon-menu-3')
            }, null, 2)
          ])
        ]),
        (!_ctx.isGridView)
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, _hoisted_20))
          : _createCommentVNode("", true)
      ])
    ]),
    (!_ctx.isCollapsed)
      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
          _createElementVNode("ul", _hoisted_22, [
            _createElementVNode("li", _hoisted_23, [
              _createElementVNode("button", {
                class: "nav-link d-flex align-items-center active",
                id: "alignment-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#alignment-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "alignment-tab-pane",
                "aria-selected": "true",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.usingCustomFilters = false))
              }, [
                _hoisted_24,
                _createTextVNode(" Quick Filters ")
              ])
            ]),
            _createElementVNode("li", _hoisted_25, [
              _createElementVNode("button", {
                class: "nav-link d-flex align-items-center",
                id: "custom-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#custom-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "custom-tab-pane",
                "aria-selected": "false",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.usingCustomFilters = true))
              }, [
                _hoisted_26,
                _createTextVNode(" Advanced Filtering ")
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_27, [
            _hoisted_28,
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filters.STATUS, (option) => {
                  return (_openBlock(), _createElementBlock("label", {
                    class: _normalizeClass(["btn btn-outline-primary btn-sm filter-button", { 'active': _ctx.tempGlobalFilters.STATUS.includes(option.value) }]),
                    key: option.value
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      value: option.value,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.tempGlobalFilters.STATUS) = $event))
                    }, null, 8, _hoisted_31), [
                      [_vModelCheckbox, _ctx.tempGlobalFilters.STATUS]
                    ]),
                    _createTextVNode(" " + _toDisplayString(option.label), 1)
                  ], 2))
                }), 128))
              ]),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-link btn-sm",
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.selectAllStatus && _ctx.selectAllStatus(...args)))
              }, "Select All"),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-link btn-sm",
                onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.deselectAllStatus && _ctx.deselectAllStatus(...args)))
              }, "Deselect All")
            ]),
            _createElementVNode("div", _hoisted_32, [
              _hoisted_33,
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("div", _hoisted_35, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filters.ALIGNMENT, (option) => {
                    return (_openBlock(), _createElementBlock("label", {
                      class: _normalizeClass(["btn btn-outline-primary btn-sm filter-button", { 'active': _ctx.tempAlignmentFilters.ALIGNMENT.includes(option.value) }]),
                      key: option.value
                    }, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        value: option.value,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.tempAlignmentFilters.ALIGNMENT) = $event))
                      }, null, 8, _hoisted_36), [
                        [_vModelCheckbox, _ctx.tempAlignmentFilters.ALIGNMENT]
                      ]),
                      _createTextVNode(" " + _toDisplayString(option.label), 1)
                    ], 2))
                  }), 128))
                ]),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-link btn-sm ms-2",
                  onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.selectAllAlignment && _ctx.selectAllAlignment(...args)))
                }, "Select All"),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-link btn-sm",
                  onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.deselectAllAlignment && _ctx.deselectAllAlignment(...args)))
                }, "Deselect All")
              ])
            ]),
            _createElementVNode("div", _hoisted_37, [
              _hoisted_38,
              _createElementVNode("div", _hoisted_39, [
                _createElementVNode("div", _hoisted_40, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filters.GCI, (option) => {
                    return (_openBlock(), _createElementBlock("label", {
                      class: _normalizeClass(["btn btn-outline-primary btn-sm filter-button", { 'active': _ctx.tempCustomFilters.GCI.includes(option.value) }]),
                      key: option.value
                    }, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        value: option.value,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.tempCustomFilters.GCI) = $event))
                      }, null, 8, _hoisted_41), [
                        [_vModelCheckbox, _ctx.tempCustomFilters.GCI]
                      ]),
                      _createTextVNode(" " + _toDisplayString(option.label), 1)
                    ], 2))
                  }), 128))
                ]),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-link btn-sm ms-2",
                  onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.selectAllGCI && _ctx.selectAllGCI(...args)))
                }, "Select All"),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-link btn-sm",
                  onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.deselectAllGCI && _ctx.deselectAllGCI(...args)))
                }, "Deselect All")
              ]),
              _hoisted_42,
              _createElementVNode("div", _hoisted_43, [
                _createElementVNode("div", _hoisted_44, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filters.STAGE, (option) => {
                    return (_openBlock(), _createElementBlock("label", {
                      class: _normalizeClass(["btn btn-outline-primary btn-sm filter-button", { 'active': _ctx.tempCustomFilters.STAGE.includes(option.value) }]),
                      key: option.value
                    }, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        value: option.value,
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.tempCustomFilters.STAGE) = $event))
                      }, null, 8, _hoisted_45), [
                        [_vModelCheckbox, _ctx.tempCustomFilters.STAGE]
                      ]),
                      _createTextVNode(" " + _toDisplayString(option.label), 1)
                    ], 2))
                  }), 128))
                ]),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-link btn-sm ms-2",
                  onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.selectAllStages && _ctx.selectAllStages(...args)))
                }, "Select All"),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-link btn-sm",
                  onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.deselectAllStages && _ctx.deselectAllStages(...args)))
                }, "Deselect All")
              ]),
              _hoisted_46,
              _createElementVNode("div", _hoisted_47, [
                _createElementVNode("div", _hoisted_48, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filters.MARTYPE, (option) => {
                    return (_openBlock(), _createElementBlock("label", {
                      class: _normalizeClass(["btn btn-outline-primary btn-sm filter-button", { 'active': _ctx.tempCustomFilters.MARTYPE.includes(option.value) }]),
                      key: option.value
                    }, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        value: option.value,
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.tempCustomFilters.MARTYPE) = $event))
                      }, null, 8, _hoisted_49), [
                        [_vModelCheckbox, _ctx.tempCustomFilters.MARTYPE]
                      ]),
                      _createTextVNode(" " + _toDisplayString(option.label), 1)
                    ], 2))
                  }), 128))
                ]),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-link btn-sm ms-2",
                  onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.selectAllMarTypes && _ctx.selectAllMarTypes(...args)))
                }, "Select All"),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-link btn-sm",
                  onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.deselectAllMarTypes && _ctx.deselectAllMarTypes(...args)))
                }, "Deselect All")
              ]),
              _createElementVNode("div", _hoisted_50, [
                _createElementVNode("div", _hoisted_51, [
                  _hoisted_52,
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-link btn-sm",
                    onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.selectAllSegments && _ctx.selectAllSegments(...args)))
                  }, "Select All"),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-link btn-sm",
                    onClick: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.deselectAllSegments && _ctx.deselectAllSegments(...args)))
                  }, "Deselect All")
                ]),
                _createElementVNode("div", _hoisted_53, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filters.SEGMENT, (option) => {
                    return (_openBlock(), _createElementBlock("label", {
                      class: _normalizeClass(["btn btn-outline-primary btn-sm filter-button", { 'active': _ctx.tempCustomFilters.SEGMENT.includes(option.value) }]),
                      key: option.value
                    }, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        value: option.value,
                        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.tempCustomFilters.SEGMENT) = $event))
                      }, null, 8, _hoisted_54), [
                        [_vModelCheckbox, _ctx.tempCustomFilters.SEGMENT]
                      ]),
                      _createTextVNode(" " + _toDisplayString(option.label), 1)
                    ], 2))
                  }), 128))
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_55, [
            _createElementVNode("div", _hoisted_56, [
              _createElementVNode("button", {
                onClick: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.applyFilters && _ctx.applyFilters(...args))),
                class: "btn btn-primary btn-sm d-flex align-items-center"
              }, [
                _createTextVNode(" Apply Filters "),
                _hoisted_57
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}